import { DamaskRedirectParamType } from 'src/Types/ReDoc/Damask';

type ActionResponsePayload = {
	hasError?: boolean;
	errorMessage?: string | null;
	result?: {
		pultStatus?: number;
	};
};

/** Приводим payload действия к строке */
export const toStringPayload = (payload?: unknown): string => {
	if (typeof payload === 'string') {
		return payload;
	}
	if (Array.isArray(payload) && typeof payload[0] === 'string') {
		return payload[0];
	}
	return '';
};

// Приводим payload действия "перенаправить" к строго типизированной форме.
// Нужен runtime-check, потому что в onActionHandler приходит unknown.
export const toRedirectPayload = (
	payload: unknown,
): DamaskRedirectParamType | null => {
	if (!payload || typeof payload !== 'object') {
		return null;
	}
	const maybePayload = payload as Partial<DamaskRedirectParamType>;
	if (typeof maybePayload.window !== 'number') {
		return null;
	}
	if (
		maybePayload.priority !== 'Low' &&
		maybePayload.priority !== 'Default' &&
		maybePayload.priority !== 'High'
	) {
		return null;
	}
	if (typeof maybePayload.callback !== 'boolean') {
		return null;
	}
	return {
		window: maybePayload.window,
		priority: maybePayload.priority,
		callback: maybePayload.callback,
	};
};

// Унифицированный разбор результата async-действий (thunk dispatch возвращает сложный unknown-объект).
const getActionResponsePayload = (
	value: unknown,
): ActionResponsePayload | null => {
	if (!value || typeof value !== 'object' || !('payload' in value)) {
		return null;
	}
	const payload = (value as { payload?: unknown }).payload;
	if (!payload || typeof payload !== 'object') {
		return null;
	}
	return payload as ActionResponsePayload;
};

// Проверяем, что действие выйти из очереди после завершающего действия завершилось успешно и сервер перевел пульт в Offline (pultStatus = 1).
export const shouldExitAfterAction = (value: unknown): boolean => {
	const payload = getActionResponsePayload(value);
	return payload?.hasError === false && payload?.result?.pultStatus === 1;
};

// Проверка, что backend вернул hasError=true.
export const hasActionError = (value: unknown): boolean => {
	return getActionResponsePayload(value)?.hasError === true;
};

// Достаём текст ошибки backend для показа в UI.
export const getActionErrorMessage = (value: unknown): string => {
	const errorMessage = getActionResponsePayload(value)?.errorMessage;
	return typeof errorMessage === 'string' ? errorMessage : '';
};

// Период опроса очереди для Enter/Damask.
export const autoUpdate = 60000;
// Для re:turn опрашиваем чаще
export const returnAutoUpdate = 10000;

/** Общие inline-стили для всех тостеров re:turn */
export const returnToastStyle: React.CSSProperties = {
	whiteSpace: 'nowrap',
	width: 'auto',
	maxWidth: 'none',
	fontFamily: 'Lato',
	fontSize: '14px',
	lineHeight: '18px',
	letterSpacing: '-0.308px',
	color: '#fff',
};

/** Общие inline-стили для кнопки «Отмена» внутри тостеров re:turn */
export const returnCancelButtonStyle: React.CSSProperties = {
	background: 'none',
	border: 'none',
	color: 'inherit',
	cursor: 'pointer',
	fontFamily: 'Lato',
	fontSize: '14px',
	fontWeight: 400,
	padding: 0,
	textDecoration: 'underline',
	whiteSpace: 'nowrap',
};
